import {AbstractNegotiationStarter} from "@/modules/diplomacy/services/AbstractNegotiationStarter";
import {injectable} from "inversify";
import {Negotiation} from "@/modules/diplomacy/entity";
import {StaffMember} from "@/modules/staff/entity";
import {StaffNegotiation} from "@/modules/staff/entity/StaffNegotiation";

@injectable()
export class StaffNegotiationStarter extends AbstractNegotiationStarter {
  protected make(target: StaffMember): Negotiation {
    const n = new StaffNegotiation();
    n.target = target;

    return n;
  }
}